import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import { ConfigProvider } from 'antd'
import zhCN from 'antd/locale/zh_CN'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import 'dayjs/locale/zh-cn'
import App from './App'
import { EnvProvider } from './providers/EnvProvider'
import './styles/globals.css'

// 配置 dayjs 插件
dayjs.extend(utc)
dayjs.locale('zh-cn')

const routerBasename = import.meta.env.BASE_URL === '/'
  ? undefined
  : import.meta.env.BASE_URL.replace(/\/$/, '')

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter basename={routerBasename}>
      <ConfigProvider locale={zhCN}>
        <EnvProvider>
          <App />
        </EnvProvider>
      </ConfigProvider>
    </BrowserRouter>
  </React.StrictMode>
)
